export default __webpack_public_path__ + "06c9c4b4d6fa1f5d64e1a34260a59a8b.svg";